import React, { useState } from "react";
import {
    Modal,
    Box,
    Typography,
    Card,
    CardContent,
    Button,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Select,
    MenuItem,
    InputLabel,
    FormControl,
    IconButton,
    AppBar,
    Tab, Tabs,
    Toolbar,
    Paper,
    TableContainer,
    Checkbox,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CloseIcon from "@mui/icons-material/Close";
import Stack from '@mui/material/Stack';
import Header from '../partials/header';
import LeftSidebar from '../partials/leftSidebar';
import sitesIcon from '../../assets/images/icon/sites.svg';
import OptionIcon from '../../assets/images/icon/Option.svg';
import customersIcon from '../../assets/images/icon/customers.svg';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { TextField } from "formik-material-ui";
// import InfoHoverTooltip from "@/components/Tooltips/InfoHover";
import { useNavigate } from "react-router-dom";
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import LicenseTabOne from "./licencesTabs/LicenseTabOne";
import LicenseTabTwo from "./licencesTabs/LicenseTabTwo";
import LicenseTabThree from "./licencesTabs/LicenseTabThree"
import { usePartnerIdContext } from "../../context/partnerIdContext";




function LicensesMain() {
    const partnerIdContext = usePartnerIdContext();

    const [activeTab, setActiveTab] = useState(0);
    const handleTabChange = (event: any, newValue: any) => {
        setActiveTab(newValue);        
        /* if(newValue === 2) {
            if(partnerIdContext) {
                partnerIdContext.setIsDisplay(false);
            }
        } else {
            if(partnerIdContext) {
                partnerIdContext.setIsDisplay(true);
            }
        } */
    }



    return (
        <Box sx={{ display: 'flex' }}>

            <Header title="Licenses" />
            <LeftSidebar />

            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    p: 3,
                    marginTop: 10,
                    padding: '0',
                }}
            >

                <TabContext value={activeTab}>
                <Box sx={{ borderBottom: 1, borderColor: '#313838', }}>
                    <Tabs value={activeTab} onChange={handleTabChange} indicatorColor="primary"
                        textColor="inherit"
                        variant="fullWidth">
                        <Tab label="Available Licenses" value={0} style={{textTransform: "none"}} />
                        {/* <Tab label="All Assigned" value={1} style={{textTransform: "none"}} /> */}
                        <Tab label="Import Licenses" value={2} style={{textTransform: "none"}} />
                    </Tabs>
                    </Box>
                    <TabPanel value={0}  >
                        <LicenseTabOne />

                    </TabPanel>
                    <TabPanel value={1}  >
                        
                        <LicenseTabTwo />
                    </TabPanel>
                    <TabPanel value={2}  >
                        
                        <LicenseTabThree setActiveTab={setActiveTab} />

                    </TabPanel>
                </TabContext>



            </Box>
        </Box>
    )
}

export default LicensesMain